const STORAGE_KEY = 'marketplace.selectedHostId';

export const getMarketplaceSelectedHostId = () => {
  try {
    const value = window.sessionStorage.getItem(STORAGE_KEY);
    return value || undefined;
  } catch (e) {
    return undefined;
  }
};

export const setMarketplaceSelectedHostId = hostId => {
  try {
    if (!hostId) {
      window.sessionStorage.removeItem(STORAGE_KEY);
      return;
    }
    window.sessionStorage.setItem(STORAGE_KEY, String(hostId));
  } catch (e) {
    // ignore storage failures
  }
};

export const resolvePreferredHostId = ({ options = [], allowedHostIds = [], queryHostId } = {}) => {
  const optionValues = options.map(o => String(o.value));
  const isValid = id => id && optionValues.includes(String(id));

  if (isValid(queryHostId)) return String(queryHostId);

  const stored = getMarketplaceSelectedHostId();
  if (isValid(stored)) return String(stored);

  const allowed = (allowedHostIds || []).map(String);
  const preferredAllowed = allowed.find(id => optionValues.includes(id));
  if (preferredAllowed) return preferredAllowed;

  return optionValues[0] || undefined;
};
